import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { WHATSAPP_NUMBER, WH_LINK } from 'shared/constants'
import { openExternalUrl } from 'shared/lib/external-open'

import { Button } from '../button'
import { Paper } from '../paper'

import s from './styles.module.scss'

export const ContactToWhatsapp = () => {
  const { t } = useTranslation()

  const contactWithUs = () => {
    openExternalUrl(`${WH_LINK}${WHATSAPP_NUMBER}`)
  }

  return (
    <Paper padding={[12, 14, 12, 14]}>
      <div className={s.container}>
        <p className={clsx(s.text, 'bold-14')}>
          {t('contact_to_whatsapp.title')}
        </p>
        <p className={clsx(s.text, 'medium-14')}>
          {t('contact_to_whatsapp.description')}
        </p>

        <Button
          variant="grey"
          onClick={contactWithUs}
        >
          <span className="semi-bold-14">
            {t('contact_to_whatsapp.button')}
          </span>
        </Button>
      </div>
    </Paper>
  )
}
